import { PRODUCT_TYPE } from './Types';
import apiClient from '../../../api/apiClient.js';
import { API_ENDPOINTS } from '../../../api/apiEndpoints.js';
import { getErrorMessage } from '../../../utils/apiError';

// Loads the default product list (GET /Products: newest first, server page size) into the
// global store. Used by the home page and the admin product list; the /products page keeps
// its own paged query state instead.
export const fetchAllProducts = async ({ dispatch }) => {
  try {
    dispatch({
      type: PRODUCT_TYPE.IS_LOADING,
      payload: true,
    });

    const response = await apiClient.get(API_ENDPOINTS.PRODUCTS.GET_ALL);

    const data = response.data?.data || {};
    const products = data.products || [];

    dispatch({
      type: PRODUCT_TYPE.PRODUCT_RESPONSE,
      payload: data,
    });

    dispatch({
      type: PRODUCT_TYPE.PRODUCTS,
      payload: products,
    });

    return response.data;
  } catch (error) {
    dispatch({
      type: PRODUCT_TYPE.ERROR,
      payload: getErrorMessage(error, 'Failed to fetch products'),
    });
    dispatch({
      type: PRODUCT_TYPE.PRODUCTS,
      payload: [],
    });
    return null;
  } finally {
    dispatch({
      type: PRODUCT_TYPE.IS_LOADING,
      payload: false,
    });
  }
};

// Loads one product into productState.productDetails (the checkout page reads it from there).
// Never throws, and keeps the previous details on failure. The product page fetches on its own
// so it can tell "not found" from "failed".
export const fetchProductById = async ({ dispatch, productid }) => {
  try {
    dispatch({
      type: PRODUCT_TYPE.IS_LOADING,
      payload: true,
    });
    const response = await apiClient.get(
      `${API_ENDPOINTS.PRODUCTS.GET_BY_ID(productid)}`
    );
    dispatch({
      type: PRODUCT_TYPE.PRODUCT_DETAILS,
      payload: response.data.data,
    });
    return response.data;
  } catch (error) {
    return null;
  } finally {
    dispatch({
      type: PRODUCT_TYPE.IS_LOADING,
      payload: false,
    });
  }
};
